export const base64ToFile = (base64String, fileName) => {
  // Check if the base64String is valid
  if (!base64String || typeof base64String !== 'string') {
    throw new Error('Invalid base64 string');
  }

  // Remove the data URL scheme part if it's included
  const base64Data = base64String?.includes('base64,')
    ? base64String?.split(',')[1]
    : base64String;

  // Further validation on base64Data
  if (!base64Data) {
    throw new Error('Invalid base64 data');
  }
  // Decode the base64 string
  const byteCharacters = atob(base64Data);

  // Convert decoded data to a byte array
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);

  // Create a Blob and File object
  const blob = new Blob([byteArray], { type: 'image/jpeg' });
  const file = new File([blob], fileName, { type: 'image/jpeg' });

  return file;
};
